import PropTypes from 'prop-types';

const Cell = ({
  time,
  title,
  start,
  end,
  isQuarter,
  isWeekend,
  isLastDay,
  isCurrentDay,
  isTodayInThisWeek,
}) => {
  const getStylesBasedOnQuarter = () => {
    if (isQuarter) {
      return 'border-r pt-4';
    }
    if (isLastDay) {
      return 'border-r';
    }
  };

  const getStylesBasedOnDay = () => {
    if (isQuarter) {
      return 'font-SFProDisplay_Bold text-sm';
    }
    const baseDayText = ' font-SFProDisplay_Medium text-xs inline-block px-1';

    if (isTodayInThisWeek && isWeekend) {
      return baseDayText + ' rounded-sm bg-blue-950/20';
    }
    if (isWeekend) {
      return baseDayText + ' rounded-sm bg-[#E2E4E8]';
    }
    if (isCurrentDay) {
      return baseDayText + ' rounded-sm bg-blue-950 text-white';
    }

    return baseDayText;
  };
  return (
    <div
      className={` absolute text-center ${
        isTodayInThisWeek && 'bg-lightBlue/20'
      }   h-full ${getStylesBasedOnQuarter()} `}
      style={time.toStyleLeftAndWidth(start, end)}
    >
      <p className={getStylesBasedOnDay()}>{title}</p>
    </div>
  );
};

Cell.propTypes = {
  time: PropTypes.shape({
    toStyleLeftAndWidth: PropTypes.func,
  }),
  title: PropTypes.string.isRequired,
  start: PropTypes.instanceOf(Date).isRequired,
  end: PropTypes.instanceOf(Date).isRequired,
};

export default Cell;
